import { useState } from 'react';
import { HeaderPage } from '@client/new/pages/layouts';
import { OTPLandingPageBuilder } from './OTPLandingPageBuilder';
import { Typography } from '@design-system/components/typography/typography';
import { BackButton } from '@client/new/pages/collection/program';

export const OfferLandingPageBuilder = (p: {
  params: { influencerId: string; offerId: string };
}) => {
  const [offerName, setOfferName] = useState<string | null>(null);

  const headerTitle = offerName ? `Offer: ${offerName}` : 'Offer Landing Page';

  return (
    <HeaderPage
      header={
        <>
          <div className="flex items-center gap-5">
            <BackButton />
            <Typography variant="headline" size="large" id="page-title">
              {headerTitle}
            </Typography>
          </div>
        </>
      }
    >
      <div className="pt-8">
        <OTPLandingPageBuilder
          embedded
          params={{
            influencerId: p.params.influencerId,
            offerId: p.params.offerId,
            programId: '0',
          }}
          onOfferNameChange={setOfferName}
        />
      </div>
    </HeaderPage>
  );
};
